<template>
    <header class="vs-table-row vs-table-header">
        <div v-if="componentMode === 'view'" class="vs-table-rows-container">
            <div v-if="getOptionValue('hasActions')" class="vs-table-row-item">عملیات</div>
            <div v-for="(item, index) in headers" class="vs-table-row-item" data-header="Header1" :style="{'flex-grow': item.grow || 1}">{{ item.title }}</div>
        </div>
        <div v-else-if="options.access && options.access.add" class="vs-table-rows-container">
            <div v-if="getOptionValue('hasActions') && componentMode === 'create'" class="vs-table-row-item">
                <button @click="onSubmitClicked" class="btn btn-secondary"><i class="icon-bd-check"></i></button>
                <button @click="onToggleMode" class="btn btn-secondary"><i class="icon-bd-close"></i></button>
            </div>
            <div v-else-if="getOptionValue('hasActions') && componentMode === 'edit'" class="vs-table-row-item justify-content-center align-items-center">
                <!--<h4 class="text-center" style="font-weight: bold; margin: 0;"><i class="icon-magnifier"></i></h4>-->
                <button @click="onToggleMode" class="btn iconed btn-secondary"><i class="icon-bd-plus"></i><span>جدید</span></button>
            </div>
            <div v-for="(item, index) in headers" v-if="!options.onCreateHeaderActionClicked && componentMode === 'create'" class="vs-table-row-item" :style="{'flex-grow': headers[index].grow || 1}">
                <div v-if="item.inHeader === undefined || item.inHeader === true" class="d-flex" :style="{'flex': item.flex || ''}">
                    <div v-if="headers[index].type === 'text' || headers[index].type === 'number'" class="d-flex" :style="{'flex': item.flex || ''}"><vs-input class="d-flex" :style="{'flex': item.flex || ''}" @dataChanged="onDataChanged" :isHeader="true" :header="headers[index]" :headerKey="index" :mode="componentMode" :placeholder="getPlaceholder(index)" :type="headers[index].type" :options="options" /></div>
                    <div v-else class="d-flex" :style="{'flex': item.flex || ''}"><component class="d-flex" :style="{'flex': item.flex || ''}" @dataChanged="onDataChanged" :is="headers[index].component" :isHeader="true" :data="item" :header="item" :headerKey="index" :mode="componentMode" :options="options" /></div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import VsInput from "./VsInput.vue";
import VsSelect from "./VsSelect.vue";
import EventBus from "./bus.js";
import VsTableMixin from "./VsTableMixin";

export default {
  name: "vs-table-header-row",
  components: {
    VsInput,
    VsSelect
  },
  props: ["row", "headers", "options", "optionDefaults", "mode"],
  data() {
    return {
      input: {},
      componentMode: [...this.mode].join("") // make a clone of mode prop
    };
  },
  mounted() {
    EventBus.$on("toggleHeaderForms", () => {
      this.onToggleMode();
    });

    EventBus.$on("onResetRowMode", () => {
      this.onToggleMode();
    });
  },
  mixins: [VsTableMixin],
  methods: {
    setRowAlignment(header) {
      if (header.rowAlignment !== undefined && header.rowAlignment != null) {
        return header.rowAlignment;
      }

      return "";
    },
    onSubmitClicked() {
      this.$emit("onCreate", this.input);
    },
    onToggleMode() {
      if (this.getOptionValue("deleteEntityAction") === "reset") {
        EventBus.$emit("onResetHeaderFormsValue");
      } else {
        // this is never called when mode is view
        if (this.componentMode === "create") {
          this.componentMode = "edit";
        } else if (this.componentMode === "edit") {
          if (this.options.onCreateHeaderActionClicked) {
            this.$emit("onCreateHeaderActionClicked", this.headers);
          } else {
            this.componentMode = "create";
          }
        }
      }

      EventBus.$emit("onHeaderDeleteActionClicked");
    },
    getPlaceholder(headerIndex) {
      if (this.componentMode === "create") {
        return this.headers[headerIndex].title + " را وارد کنید";
      } else {
        return "جستجو با " + this.headers[headerIndex].title;
      }
    },
    onDataChanged(property, value) {
      this.$set(this.input, property, value);
      if (this.componentMode === "edit") {
        this.$emit("dataChanged", property, value);
      }
    }
  },
  watch: {
    mode(val) {
      this.componentMode = val;
    }
  }
};
</script>

<style scoped lang="scss">
button i {
  font-size: 1.1rem;
}

button {
  height: fit-content;
}

@import "./VsTable.scss";
</style>
